// React comes from 'react', not 'react-native'. This previously read
// `import React, {...} from 'react-native'`, which silently bound React to
// undefined - harmless only because the JSX automatic runtime never
// references it.
import { KeyboardAvoidingView, Modal, ModalProps, Platform } from 'react-native'
import React, { ReactNode } from 'react'
import { useKeyborad } from '../hooks/useKeyborad'

type Props = ModalProps & {
  children: ReactNode,
  keyboardView?: boolean
}

export const CustomModal = ({ children, keyboardView, ...rest }: Props) => {

  const isKeyboadOpen = useKeyborad()
  return (
    <Modal statusBarTranslucent supportedOrientations={["landscape", "landscape-left", "landscape-right", "portrait"]} presentationStyle='overFullScreen' {...rest}>
      {keyboardView ? <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : isKeyboadOpen ? "padding" : undefined} enabled style={{ flex: 1 }}>
        {children}
      </KeyboardAvoidingView> :
        children
      }
    </Modal>
  )
}


